import React from 'react';
import styled from 'styled-components';
import { Button } from 'react-bootstrap'
const Item = ({ layouts, onCreateNewLayout }) => {
    return <div className="d-flex flex-wrap align-items-center justify-content-center">
        {
            layouts.map((item, index) => {
                const StyledWrapper = styled.div`${item.css}`
                return <div className="p-2">
                <button key={index} className="layout-btn button layout-preview" onClick={onCreateNewLayout(item.id)}>
                    <div className="button-wrapper">
                        <div className="layout">
                            <StyledWrapper>
                                {
                                    item.zones.map((zItem, zIndex) => <div id={zItem.id} className="zone"></div>)
                                }
                            </StyledWrapper>
                        </div>
                        <span className="layout_title">{item.name}</span>
                    </div>
                </button>
                </div>
            })
        }

    </div>

}

export default Item;